// extracted by mini-css-extract-plugin
export default {"root":"RowStatsBox_root__Oc9U8","box":"RowStatsBox_box__HAxhD","item":"RowStatsBox_item__-+Vbb","row":"RowStatsBox_row__NSawk"};